import * as React from 'react'
import { TextFieldProps } from '@mui/material/TextField'
import { FormattedMessage } from 'react-intl'
import { TextField } from './styles'

type Props = TextFieldProps & {
  name: string
  testId?: string
  disableSubmit?: boolean
}

const TextFieldMui = ({
  label, name, inputRef, margin = 'normal', size = 'small', testId, disableSubmit = false, ...props
}: Props) => (
  <TextField
    id={name}
    name={name}
    inputRef={inputRef}
    label={<FormattedMessage id={`${label ?? name}`} />}
    variant='outlined'
    margin={margin}
    size={size}
    onKeyPress={disableSubmit ? undefined : (event) => {
      if (event.key === 'Enter') {
        const submitButton = document.querySelector('.submit-button') as any
        const button = document.querySelector('button')
        const inputs = document.getElementsByTagName('input') as any
        const activeInputs = [...inputs].filter((input) => !input.disabled)

        for (let index = 0; index < inputs.length; index += 1) {
          if (activeInputs[index] === document.getElementsByName(name)[0]) {
            if (index === activeInputs.length - 1) {
              if (submitButton != null) submitButton.click()
              else if (button != null) button.click()
              break
            }
            activeInputs[index + 1].focus()
          }
        }
      }
    }}
    inputProps={{ 'data-testid': testId }}
    {...props}
  />
)

export default React.memo(TextFieldMui)
